import Link from "next/link";

export const LinkableArea = ({
  rawLink,
  formattedLink,
  className,
  children
}) => {
  // Handle linking to a shopify collection or product
  if (rawLink.handle) {
    return (
      <Link
        href={{ pathname: formattedLink.href, query: formattedLink.query }}
        passHref
        prefetch={false}
        className={className}
      >
        <a>{children}</a>
      </Link>
    )
  }

  // handle linking to a nextJS page
  if (rawLink.slug) {
    return (
      <Link
        href={formattedLink.href}
        passHref
        prefetch={false}
        className={className}
      >
        <a>{children}</a>
      </Link>
    );
  }

  // handle external link
  if (rawLink.link) {
    return (
      <a
        href={formattedLink.href}
        target={formattedLink.blank ? "_blank" : "_self"}
        className={className}
      >
        {children}
      </a>
    );
  }

  // default
  return (
    <a
      href={formattedLink.href}
      className={className}
    >
      {children}
    </a>
  )
}